module.exports = __webpack_public_path__ + "img/green.2e260e94.gif";